import { Button, Notification, Text, TextInput, Title } from '@mantine/core';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLanguageAwareRouting } from '@gofranz/common-components';
import { useRustyState } from '../../state';

export function DataPrivacyPage() {
  const { t } = useTranslation();
  const { api } = useRustyState.getState();
  const { createLanguageURL } = useLanguageAwareRouting();

  const [exporting, setExporting] = useState(false);
  const [exportError, setExportError] = useState('');
  const [deleteConfirmation, setDeleteConfirmation] = useState('');
  const [deleting, setDeleting] = useState(false);
  const [deleteError, setDeleteError] = useState('');

  const handleExport = async () => {
    setExporting(true);
    setExportError('');
    try {
      const data = await api.exportAccountData();
      const blob = new Blob([JSON.stringify(data, null, 2)], {
        type: 'application/json',
      });
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `formshive-export-${new Date().toISOString().split('T')[0]}.json`;
      a.click();
      URL.revokeObjectURL(url);
    } catch {
      setExportError(t('dataPrivacy.exportError'));
    } finally {
      setExporting(false);
    }
  };

  const handleDelete = async () => {
    if (deleteConfirmation !== 'DELETE') return;
    setDeleting(true);
    setDeleteError('');
    try {
      await api.deleteAccount(deleteConfirmation);
      await useRustyState.getState().logout();
      window.location.replace(createLanguageURL('/'));
    } catch {
      setDeleteError(t('dataPrivacy.deleteError'));
      setDeleting(false);
    }
  };

  return (
    <>
      <Title order={2} mb="xs">
        {t('dataPrivacy.title')}
      </Title>

      <Title order={3} mb="xs" mt="md">
        {t('dataPrivacy.exportTitle')}
      </Title>
      <Text mb="md">{t('dataPrivacy.exportDescription')}</Text>
      {exportError && (
        <Notification color="red" mb="md" onClose={() => setExportError('')}>
          {exportError}
        </Notification>
      )}
      <Button onClick={handleExport} loading={exporting}>
        {t('dataPrivacy.exportButton')}
      </Button>

      <Title order={3} mb="xs" mt="xl" c="red">
        {t('dataPrivacy.deleteTitle')}
      </Title>
      <Text mb="md" c="dimmed">
        {t('dataPrivacy.deleteWarning')}
      </Text>
      {deleteError && (
        <Notification color="red" mb="md" onClose={() => setDeleteError('')}>
          {deleteError}
        </Notification>
      )}
      <TextInput
        label={t('dataPrivacy.deleteConfirmation')}
        placeholder={t('dataPrivacy.typeDelete')}
        value={deleteConfirmation}
        onChange={(e) => setDeleteConfirmation(e.currentTarget.value)}
        mb="md"
        maw={300}
      />
      <Button
        color="red"
        onClick={handleDelete}
        loading={deleting}
        disabled={deleteConfirmation !== 'DELETE'}
      >
        {t('dataPrivacy.deleteButton')}
      </Button>
    </>
  );
}
